import { vehicles } from "../data/vehicles";
import CheckboxDropdown from "./CheckboxDropdown";

const makes = [...new Set(vehicles.map((v) => v.brand))].sort();
const allModels = [...new Set(vehicles.map((v) => v.type))].sort();

function VehicleSearch({ selectedMakes, selectedModels, onToggleMake, onToggleModel, onSelectAllMakes, onSelectAllModels, onSearch }) {
  return (
    <div className="vehicle-search-panel">
      <h3 className="vehicle-search-title">Shop for Armored Vehicles</h3>
      <div className="vehicle-search-fields">
        <div className="vehicle-search-field">
          <CheckboxDropdown
            label="Make"
            options={makes}
            selected={selectedMakes}
            onToggle={onToggleMake}
            onSelectAll={(checked) => onSelectAllMakes(checked)}
          />
        </div>
        <div className="vehicle-search-field">
          <CheckboxDropdown
            label="Model"
            options={allModels}
            selected={selectedModels}
            onToggle={onToggleModel}
            onSelectAll={(checked) => onSelectAllModels(checked)}
          />
        </div>
        <button type="button" className="vehicle-search-btn" onClick={onSearch}>
          SEARCH &gt;
        </button>
      </div>
    </div>
  );
}

export default VehicleSearch;
